.header {
	height: 8%;
	flex-wrap: wrap;
	align-items: center;
	border-bottom: 0.5px solid #dee2e6;

	.optionButton {
		display: inline-flex;
		background-color: #fafafa;
		padding: 7px 10px;
		border-radius: 10px;
		font-size: 15px;
		font-weight: 500;
		margin-right: 10px;
		cursor: pointer;

		span {
			margin-left: 27px;
		}

		&:hover {
			background-color: #7fb02f;
			color: white;
		}

		.icon {
			margin-right: 7px;
			margin-top: 3px;
		}

		&.newInventory {
			background-image: url("../../../../../assets/images/desktop/cargarnegro.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;

			&:hover {
				background-image: url("../../../../../assets/images/desktop/cargarblanco.svg");
			}

			&.active {
				background-image: url("../../../../../assets/images/desktop/cargarblanco.svg");
				color: white;
				background-color: #7fb02f;
			}
		}

		&.exportInventory {
			background-image: url("../../../../../assets/images/desktop/descargarnegro.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;

			&:hover {
				background-image: url("../../../../../assets/images/desktop/descargarblanco.svg");
			}

			&.active {
				background-image: url("../../../../../assets/images/desktop/descargarblanco.svg");
				color: white;
				background-color: #7fb02f;
			}
		}
	}

	.separator {
		width: 98%;
		margin-top: 0.5em;
		margin-bottom: 0.5em;
	}
}
